import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import FundingAuthorization from "./EditFunding/FundingAuthorization";
import ReviewFunding from "./ReviewFunding/ReviewFunding";

export const FundingPackagesRoute = () => {
  const { user } = useContext(UserContext);
  if (user?.internalUser?.internalUserRoles?.find((iu) => iu.internalUserRoleType?.name === "Wire Approver")) {
    return <ReviewFunding />;
  }
  return <FundingAuthorization />;
};
